import { HttpData, HttpNoData } from "./core";

export function getColumnsAsync(pickId, jwt){

    return HttpNoData(`/api/picks/v1/columns/${pickId}`, 'GET', jwt);
}

export function getOrdersCurrentAsync(jwt){

    return HttpNoData(`/api/orders/v1/orders/currents`, 'GET', jwt);
}

export function getOrdersWaitingPayment(jwt){

    return HttpNoData(`/api/orders/v1/orders/waiting/payments/companies`, 'GET', jwt);
}

export function paidOrder(jwt, id){

    return HttpNoData(`/api/orders/v1/orders/${id}/paid`, 'PUT', jwt);
}

export function getOrderItems(orderId, jwt){

    return HttpNoData(`/api/orders/v1/orders/${orderId}/items`, 'GET', jwt);
}

export function updateOrderColumn(orderId, newColumnId, clientMessage, jwt){

    return HttpData(`/api/orders/v1/orders/${orderId}/column`, 'PUT', jwt, {
        newColumnId, clientMessage
    });
}

export function getProcessingItems(orderId, jwt){

    return HttpNoData(`/api/orders/v1/processing/on/order/${orderId}/items`, 'GET', jwt);
}

export function orderClose(orderId, jwt){

    return HttpNoData(`/api/orders/v1/orders/${orderId}/close`, 'PUT', jwt);
}

export function getRefundRequests(jwt){
    return HttpNoData('/api/orders/v1/orders/returns', 'GET', jwt);
}

export function approveRefund(orderId, jwt){
    return HttpNoData(`/api/orders/v1/orders/returns/${orderId}/approve`, 'PUT', jwt);
}

export function rejectRefund(orderId, comment, jwt){
    return HttpData(`/api/orders/v1/orders/returns/${orderId}/reject`, 'PUT', jwt, { comment });
}

export function completeRequisitesRefund(orderId, jwt){
    return HttpNoData(`/api/orders/v1/orders/returns/${orderId}/complete-requisites`, 'PUT', jwt);
}
